// NOTE: For now Intl.Segmenter is supported only in this file
// For reference: https://github.com/scaleapi/scaleapi/pull/93410#discussion_r1729336930
/* eslint-disable @typescript-eslint/no-unused-vars */
import { memo, useState } from 'react';
import { Chip } from '@scale/scaleui';

import { removeMarkdown, countWords } from './utils';
import { useChatStoreExtract } from 'react-scale/components/scalers/tasks/Chat/hooks/ChatStore.hooks';

import { useDebounce, useMount } from 'react-use-v13';

type Props = {
  text: string;
  active?: boolean;
};

// TODO: @Lajos This should be chat specific
// We need to place this into chat code boundaries
const WordCounter = ({ text, active = true }: Props) => {
  const [count, setCount] = useState(0);
  const languageCode = useChatStoreExtract(store => store.languageCode);

  useDebounce(
    async () => {
      const wordCount = countWords(await removeMarkdown(text), languageCode);
      setCount(wordCount);
    },
    200,
    [text, languageCode],
  );

  useMount(async () => {
    const wordCount = countWords(await removeMarkdown(text), languageCode);
    setCount(wordCount);
  });

  const formattedCount = count.toLocaleString('en-US');

  return <Chip data-testid="wordCounter" label={`${formattedCount} words`} active={active} />;
};

export default memo(WordCounter);
